<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>MOT DE PASSE OUBLIÉ</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>MOT DE PASSE OUBLIÉ</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-area pt-5">
<!--    <div class="container">-->
<!--        <div class="alert-message alert-message-info">-->
<!--            <h4>Mot de passe oublié</h4>-->
<!--            <p>-->
<!--                L'accès au détail de cet appel d'offres nécessite une autorisation spéciale de connexion à votre compte fournisseur. Veuillez-->
<!--                saisir votre authentifications nécessaires pour vous autoriser à voir le détail de cet appel d'offres.-->
<!--            </p>-->
<!--            <p>-->
<!--                Ou si vous êtes à votre fois de consulter notre, nous vous recommandons de bien vouloir vous enregistrer afin de bénéficier aux opportunités d'appels d'offres-->
<!--            </p>-->
<!--            <p>-->
<!--                Merci pour la compréhension.-->
<!--            </p>-->
<!--        </div>-->
<!--    </div>-->
    <div class="container mt-5">
        <div class="login-page">
            <div class="form">
                <form
                    class="login-form"
                    [formGroup]="form"
                    (ngSubmit)="onSubmit()"
                >
                    <div class="form-group col-lg-4 text-start">
                        <label for="email">Adresse électronique <span class="text-danger">(OBLIGATOIRE)</span></label>
                        <input
                            class="form-control"
                            type="email"
                            id="email"
                            formControlName="email"
                            placeholder="Saisissez votre email"
                        />
                    </div>

                    <re-captcha
                        class="w-100"
                        id="recaptcha"
                        formControlName="recaptcha"
                    />

                    <button type="submit" class="mt-5 btn btn-green w-25" [disabled]="form.invalid || loading">
                        ENVOYER <i *ngIf="loading" class="icofont-spinner-alt-1 icofont-spin"></i>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>

<section class="forgot-password-info-section">
    <div class="container">
        <div class="info-grid">
            <div class="info-card">
                <div class="info-icon">
                    <i class="icofont-shield"></i>
                </div>
                <h4 class="info-title">Sécurisé et Fiable</h4>
                <p class="info-description">
                    Votre email est protégé et le lien de réinitialisation expire automatiquement pour votre sécurité
                </p>
            </div>
            
            <div class="info-card">
                <div class="info-icon">
                    <i class="icofont-clock-time"></i>
                </div>
                <h4 class="info-title">Rapide et Simple</h4>
                <p class="info-description">
                    Recevez le lien de réinitialisation en quelques minutes et récupérez l'accès à votre compte
                </p>
            </div>
            
            <div class="info-card">
                <div class="info-icon">
                    <i class="icofont-support"></i>
                </div>
                <h4 class="info-title">Support 24/7</h4>
                <p class="info-description">
                    Notre équipe est disponible pour vous aider si vous rencontrez des difficultés
                </p>
            </div>
        </div>
    </div>
</section>

<section class="forgot-password-steps-section">
    <div class="container">
        <div class="steps-header text-center">
            <h3 class="steps-title">Comment ça marche ?</h3>
            <p class="steps-subtitle">Suivez ces étapes simples pour récupérer votre mot de passe</p>
        </div>
        
        <div class="steps-timeline">
            <div class="step-item">
                <div class="step-number">1</div>
                <div class="step-content">
                    <div class="step-icon">
                        <i class="icofont-email"></i>
                    </div>
                    <h4 class="step-title">Saisissez votre email</h4>
                    <p class="step-description">Entrez l'adresse email associée à votre compte</p>
                </div>
            </div>
            
            <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-content">
                    <div class="step-icon">
                        <i class="icofont-check-circled"></i>
                    </div>
                    <h4 class="step-title">Vérifiez votre boîte mail</h4>
                    <p class="step-description">Cliquez sur le lien de réinitialisation reçu</p>
                </div>
            </div>
            
            <div class="step-item">
                <div class="step-number">3</div>
                <div class="step-content">
                    <div class="step-icon">
                        <i class="icofont-lock"></i>
                    </div>
                    <h4 class="step-title">Créez un nouveau mot de passe</h4>
                    <p class="step-description">Choisissez un nouveau mot de passe sécurisé</p>
                </div>
            </div>
        </div>
    </div>
</section>